import KPICards from "./KPICards";
import RevenueChart from "./RevenueChart";
import GrowthChart from "./GrowthChart";
import ChurnChart from "./ChurnChart";
import QbBalanceCard from "./QbBalanceCard";

export default function Overview({ state }) {
  const { clients, offers, payments } = state;
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <QbBalanceCard />
      </div>
      <KPICards clients={clients} offers={offers} payments={payments} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <RevenueChart payments={payments} />
        <GrowthChart clients={clients} />
      </div>
      <ChurnChart clients={clients} />
    </div>
  );
}
